<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item x-header" slot="bc_code">
            <label class="weui-form-preview__label">{{
              customLabel.bc_code || "条码号"
            }}</label>
            <span class="weui-form-preview__value">{{ form.bc_code }}</span>
          </div>
          <div class="weui-form-preview__item" slot="bc_prcode">
            <label class="weui-form-preview__label">{{
              customLabel.bc_prcode || "物料号"
            }}</label>
            <span class="weui-form-preview__value">{{ form.bc_prcode }}</span>
          </div>
          <div class="weui-form-preview__item" slot="bc_prname">
            <label class="weui-form-preview__label">{{
              customLabel.bc_prname || "物料名称"
            }}</label>
            <span class="weui-form-preview__value">{{ form.bc_prname }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="bc_madetime"
            v-if="form.bc_madetime"
          >
            <label class="weui-form-preview__label">{{
              customLabel.bc_madetime || "生产日期"
            }}</label>
            <span class="weui-form-preview__value">{{
              dateFormat(form.bc_madetime, "yyyy-MM-dd")
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="bc_madein"
            v-if="form.bc_madein"
          >
            <label class="weui-form-preview__label">{{
              customLabel.bc_madein || "产地"
            }}</label>
            <span class="weui-form-preview__value">{{ form.bc_madein }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="bc_weight"
            v-if="form.bc_weight"
          >
            <label class="weui-form-preview__label">{{
              customLabel.bc_weight || "重量"
            }}</label>
            <span class="weui-form-preview__value">{{ form.bc_weight }}KG</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pr_orispeccode"
            v-if="form.pr_orispeccode"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pr_orispeccode || "型号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.pr_orispeccode
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pr_spec"
            v-if="form.pr_spec"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pr_spec || "规格"
            }}</label>
            <span class="weui-form-preview__value">{{ form.pr_spec }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pr_brand"
            v-if="form.pr_brand"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pr_brand || "品牌"
            }}</label>
            <span class="weui-form-preview__value">{{ form.pr_brand }}</span>
          </div>
          <div class="weui-form-preview__item" slot="bc_bacode">
            <label class="weui-form-preview__label">{{
              customLabel.bc_bacode || "批次号"
            }}</label>
            <span class="weui-form-preview__value">{{ form.bc_bacode }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="bc_vendcode"
            v-if="form.bc_vendcode"
          >
            <label class="weui-form-preview__label">{{
              customLabel.bc_vendcode || "供应商编号"
            }}</label>
            <span class="weui-form-preview__value">{{ form.bc_vendcode }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="bc_vendname"
            v-if="form.bc_vendname"
          >
            <label class="weui-form-preview__label">{{
              customLabel.bc_vendname || "供应商名称"
            }}</label>
            <span class="weui-form-preview__value">{{ form.bc_vendname }}</span>
          </div>
          <div class="weui-form-preview__item" slot="bc_qty">
            <label class="weui-form-preview__label">{{
              customLabel.bc_qty || "数量"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.bc_qty }} {{ form.pr_unit }}</span
            >
          </div>
          <div
            class="weui-form-preview__item"
            slot="bc_box_count"
            v-if="form.bc_box_count"
          >
            <label class="weui-form-preview__label">{{
              customLabel.bc_box_count || "箱数"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.bc_box_count
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="bc_box_number"
            v-if="form.bc_box_number"
          >
            <label class="weui-form-preview__label">{{
              customLabel.bc_box_number || "箱号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.bc_box_number
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="bc_box_spec"
            v-if="form.bc_box_spec"
          >
            <label class="weui-form-preview__label">{{
              customLabel.bc_box_spec || "包装规格"
            }}</label>
            <span class="weui-form-preview__value">{{ form.bc_box_spec }}</span>
          </div>
          <div class="weui-form-preview__item" slot="bc_status">
            <label class="weui-form-preview__label">{{
              customLabel.bc_status || "有效状态"
            }}</label>
            <span class="weui-form-preview__value">{{
              parseStatus(form.bc_status)
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="bc_use_status">
            <label class="weui-form-preview__label">{{
              customLabel.bc_use_status || "使用状态"
            }}</label>
            <span class="weui-form-preview__value">{{
              parseUseStatus(form.bc_use_status)
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="bc_source_code"
            v-if="form.bc_source_code"
          >
            <label class="weui-form-preview__label">{{
              customLabel.bc_source_code || "来源条形码"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.bc_source_code
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="bc_shelflife"
            v-if="form.bc_shelflife"
          >
            <label class="weui-form-preview__label">{{
              customLabel.bc_shelflife || "保质期(天)"
            }}</label>
            <span class="weui-form-preview__value"
              >{{ form.bc_shelflife }} 天</span
            >
          </div>
          <div
            class="weui-form-preview__item"
            slot="bc_lifedate"
            v-if="form.bc_lifedate"
          >
            <label class="weui-form-preview__label">{{
              customLabel.bc_lifedate || "保质期"
            }}</label>
            <span class="weui-form-preview__value">{{
              dateFormat(form.bc_lifedate, "yyyy-MM-dd")
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="bc_crclass">
            <label class="weui-form-preview__label">{{
              customLabel.bc_crclass || "类型"
            }}</label>
            <span class="weui-form-preview__value">{{
              parseClass(form.bc_crclass)
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="wh_code"
            v-if="form.wh_code"
          >
            <label class="weui-form-preview__label">{{
              customLabel.wh_code || "仓库编号"
            }}</label>
            <span class="weui-form-preview__value">{{ form.wh_code }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="wh_description"
            v-if="form.wh_description"
          >
            <label class="weui-form-preview__label">{{
              customLabel.wh_description || "仓库名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.wh_description
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="bc_cust_code"
            v-if="form.bc_cust_code && form.bc_crclass == 'CustDeliverBarCode'"
          >
            <label class="weui-form-preview__label">{{
              customLabel.bc_cust_code || "客户编号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.bc_cust_code
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="bc_cust_name"
            v-if="form.bc_cust_name && form.bc_crclass == 'CustDeliverBarCode'"
          >
            <label class="weui-form-preview__label">{{
              customLabel.bc_cust_name || "客户名称"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.bc_cust_name
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="bc_other_prcode"
            v-if="
              form.bc_other_prcode && form.bc_crclass == 'CustDeliverBarCode'
            "
          >
            <label class="weui-form-preview__label">{{
              customLabel.bc_other_prcode || "对方料号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.bc_other_prcode
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="bc_origin_biztype"
            v-if="form.bc_origin_biztype"
          >
            <label class="weui-form-preview__label">{{
              customLabel.bc_origin_biztype || "源单据类型"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.bc_origin_biztype
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="bc_origin_bizcode"
            v-if="form.bc_origin_bizcode"
          >
            <label class="weui-form-preview__label">{{
              customLabel.bc_origin_bizcode || "源单据编号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.bc_origin_bizcode
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="bc_origin_bizdetno"
            v-if="form.bc_origin_bizdetno"
          >
            <label class="weui-form-preview__label">{{
              customLabel.bc_origin_bizdetno || "源单据行号"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.bc_origin_bizdetno
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="bc_origin_orderprice"
            v-if="form.bc_origin_orderprice"
          >
            <label class="weui-form-preview__label">{{
              customLabel.bc_origin_orderprice || "源单据含税单价"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.bc_origin_orderprice
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="bc_origin_taxprice"
            v-if="form.bc_origin_taxprice"
          >
            <label class="weui-form-preview__label">{{
              customLabel.bc_origin_taxprice || "源单据不含税单价"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.bc_origin_taxprice
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="bc_origin_taxrate"
            v-if="form.bc_origin_taxrate"
          >
            <label class="weui-form-preview__label">{{
              customLabel.bc_origin_taxrate || "源单据税率"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.bc_origin_taxrate
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pr_text1"
            v-if="form.pr_text1"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pr_text1 || "自定义字段1"
            }}</label>
            <span class="weui-form-preview__value">{{ form.pr_text1 }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pr_text2"
            v-if="form.pr_text2"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pr_text2 || "自定义字段2"
            }}</label>
            <span class="weui-form-preview__value">{{ form.pr_text2 }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pr_text3"
            v-if="form.pr_text3"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pr_text3 || "自定义字段3"
            }}</label>
            <span class="weui-form-preview__value">{{ form.pr_text3 }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pr_text4"
            v-if="form.pr_text4"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pr_text4 || "自定义字段4"
            }}</label>
            <span class="weui-form-preview__value">{{ form.pr_text4 }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            slot="pr_text5"
            v-if="form.pr_text5"
          >
            <label class="weui-form-preview__label">{{
              customLabel.pr_text5 || "自定义字段5"
            }}</label>
            <span class="weui-form-preview__value">{{ form.pr_text5 }}</span>
          </div>
        </custom-layout>
        <file-list :fileList="attachs" />
      </div>
    </div>
  </div>
</template>
  
<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
const allFields = [
  "bc_code",
  "bc_prname",
  "bc_madetime",
  "bc_madein",
  "bc_weight",
  "bc_prcode",
  "bc_prname",
  "pr_orispeccode",
  "pr_spec",
  "pr_brand",
  "bc_bacode",
  "bc_vendcode",
  "bc_vendname",
  "bc_qty",
  "bc_box_count",
  "bc_box_number",
  "bc_box_spec",
  "bc_status",
  "bc_use_status",
  "bc_source_code",
  "bc_shelflife",
  "bc_lifedate",
  "bc_crclass",
  "wh_code",
  "wh_description",
  "bc_cust_code",
  "bc_cust_name",
  "bc_other_prcode",
  "bc_origin_biztype",
  "bc_origin_bizcode",
  "bc_origin_bizdetno",
  "bc_origin_orderprice",
  "bc_origin_taxprice",
  "bc_origin_taxrate",
  "pr_text1",
  "pr_text2",
  "pr_text3",
  "pr_text4",
  "pr_text5",
];

export default {
  components: {
    CustomLayout,
    FileList,
  },
  props: {
    code: String,
  },
  data() {
    return {
      form: {},
      customViewConfig: [],
      customLabel: {},
      attachs:[]
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getData();
    });
  },
  methods: {
    getData() {
      var me = this,
        code = me.code;

      if (!code) {
        return;
      }
      me.$loading({
        url: `/api/storage/barCode/showbar?code=${code}`,
      }).then(function (res) {
        if (res.data) {
          me.form = res.data.barCodeDTO;
          me.attachs = res.data.attachs
          
          if (res.data.content) {
            let fields = JSON.parse(res.data.content),
              customLabel = {};
            fields.forEach((field) => {
              field.name = field.key;
              customLabel[field.key] = field.text;
            });
            // 补充hidden设置
            allFields.forEach((name, index) => {
              if (!customLabel[name]) {
                fields.push({
                  name,
                  hidden: true,
                  index: customLabel.length + index + 1,
                });
              }
            });
            me.customLabel = customLabel;
            me.customViewConfig = [
              {
                position: "main",
                content: JSON.stringify(fields),
              },
            ];
          } else {
            me.customViewConfig = [];
            me.customLabel = {};
          }
        } else {
          me.form = {};
          me.customViewConfig = [];
          me.customLabel = {};
        }
      });
    },
    parseStatus(status) {
      return ["失效", "创建", "生效"][status || 0] || "失效";
    },
    parseUseStatus(status) {
      return ["未使用", "已使用", "已入库", "已出库"][status || 0] || "未使用";
    },
    parseClass(cls) {
      return (
        {
          AddStockBarCode: "入库条码",
          MakeInBarCode: "完工条码",
          CustDeliverBarCode: "客户条码",
        }[cls] || cls
      );
    },
  },
};
</script>
<style>
.x-header {
  border-bottom: 1px solid var(--weui-FG-3);
  margin-bottom: 10px;
  font-size: 1.6em;
}
</style>